import React, { CSSProperties } from 'react';

import { DeepPartial } from 'ia-react-core/~/interfaces/DeepPartial';
import { Theme } from 'ia-react-core/~/interfaces/Theme';

import baseTheme from '../baseTheme';
import { ReactComponent as LogoFr } from './assets/images/iAGF.svg';
import { ReactComponent as HorizontalLogoFr } from './assets/images/iAGF-H.svg';
import { ReactComponent as HorizontalLogoInvFr } from './assets/images/iAGF-H-Inv.svg';
import { ReactComponent as LogoEn } from './assets/images/iAFG.svg';
import { ReactComponent as HorizontalLogoEn } from './assets/images/iAFG-H.svg';
import { ReactComponent as HorizontalLogoInvEn } from './assets/images/iAFG-H-Inv.svg';
import { ReactComponent as LoadingLogo } from './assets/images/iALoadingLogo.svg';
import { ReactComponent as ExpandLess } from '../../icons/expandLess.svg';
import { ReactComponent as ExpandMore } from '../../icons/expandMore.svg';

import fr from './translations/fr';
import en from './translations/en';

interface IconProps {
  style: CSSRule;
  className: string;
  focusable: boolean;
  role: string;
}

export type BaseIaTheme = Theme;

const baseIaTheme: DeepPartial<Theme> = (() => ({
  name: 'ia',
  ...baseTheme,
}))();

baseIaTheme.icons = {
  chevronUp: ({ style, className, focusable, role }: IconProps) => (
    <ExpandLess
      style={style as CSSProperties}
      className={className}
      focusable={focusable}
      role={role}
    />
  ),
  chevronDown: ({ style, className, focusable, role }: IconProps) => (
    <ExpandMore
      style={style as CSSProperties}
      className={className}
      focusable={focusable}
      role={role}
    />
  ),
} as DeepPartial<Theme>['icons'];

baseIaTheme.SpinningLoader = {
  viewBox: '0 0 1024 1024',
  width: '16px',
  height: '16px',
  spinnerColor: 'rgb(0, 64, 164)',
  spinnerIconWidth: '80px',
  spinnerIconHeight: '40px',
  spinnerIconMarginTop: '19px',
};

baseIaTheme.MainLogoHorizontal = {
  width: '133px',
  height: '32px',
};

baseIaTheme.assets = {
  logoFr: LogoFr,
  logoEn: LogoEn,
  horizontalLogoFr: HorizontalLogoFr,
  horizontalLogoEn: HorizontalLogoEn,
  horizontalLogoInvFr: HorizontalLogoInvFr,
  horizontalLogoInvEn: HorizontalLogoInvEn,
  loadingLogo: LoadingLogo,
};

baseIaTheme.translations = {
  fr,
  en,
};

/**
 * @since 0.1.0
 * @visibleName baseIaTheme
 * @component
 */
export default baseIaTheme as Theme;
